export const createIsAnyAudioNode = (audioNodeStore, isNativeAudioNode) => {
  return anything => audioNodeStore.has(anything) || isNativeAudioNode(anything);
};